var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentGenre)?_c('GenreDetail',{attrs:{"genre":_vm.currentGenre}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }